export default __webpack_public_path__ + "static/media/playngo.2470a41e.png";